module.exports = "<button id=csv-export class=\"btn btn-info pull-right\" ng-csv=getCsvData() csv-header=getCsvHeader() field-separator={{fieldSeparator}} filename={{filename}} csv-label=false lazy-load=true title=\"{{'AstralSituationRecord.csvDownload'| translate}}\"> <i class=\"fa fa-download\" aria-hidden=true></i> </button> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/csvExport/csvExport.html
// module id = 274
// module chunks = 0